// extracted by mini-css-extract-plugin
export default {"section":"Academy_section__oIHCJ"};